<template>
  <v-app>
    <transition name="fade">
      <div>
        <router-view></router-view>
      </div>
    </transition>
  </v-app>
</template>

<script>
  import { interceptors } from '@/helpers/api'
  import { getUserApplicationRole, getUserApplicationPermissions, checkPermissions } from '@/helpers/utilities'

export default {
  data: () => ({
    userPermissions: []
  }),
  created() {
    interceptors((err) => {
      if(err.response.status === 401) {
        //Auth.remove()
        //revoke() clear local storage
        this.$store.commit('SET_USER', null);
        if(this.$route.name != 'login') {
          return this.$router.push({ name: 'login'})
        }
      }

      if(err.response.status === 500) {
        //Flash.setError(err.response.statusText)
        return this.$router.push({name: '500'})
      }

      if(err.response.status === 403) {
      //https://www.bountysource.com/issues/38142121-missing-param-for-named-route-notfound-expected-0-to-be-defined
        return this.$router.push({ name: '403'}) 
      }

      if(err.response.status === 404) {
      //https://www.bountysource.com/issues/38142121-missing-param-for-named-route-notfound-expected-0-to-be-defined
        return this.$router.push({ name: '404', params: { '0': '404' } }) 
      }

    })
    
    /*if(this.$route.name != 'login' && this.$route.name != 'passwordResetRequest' && this.$route.name != 'passwordReset' && this.$route.name) {
      if(this.$route.meta.permissions !== 'undefined') {
        this.userPermissions = getUserApplicationPermissions();
        window.console.log("User Permissions: ")
        window.console.log(this.userPermissions)
        window.console.log(checkPermissions(this.$route.meta.permissions, this.userPermissions))
      }
    }*/
  },

  mounted() {
    /*getUserApplicationRole()
    getUserApplicationPermissions()
    window.console.log(checkPermissions(["test", "sobec-view-user"], getUserApplicationPermissions()))*/
    //window.console.log("Meta:")
    //window.console.log(this.$route.meta.permissions)
  }
}
</script>

<style>
  html { overflow-y: auto }
  .pointer {cursor: pointer;}
  .fade-enter-active, .fade-leave-active {
        transition-property: opacity;
        transition-duration: .25s;
  }

  .fade-enter-active {
      transition-delay: .25s;
  }

  .fade-enter, .fade-leave-active {
      opacity: 0
  }
</style>
